import { QuoteEventType } from '@features/invoices/enums/quoteEventType'

export const quoteStatusToTranslationKey: Record<QuoteEventType, string> = {
  [QuoteEventType.DeliveryEmailSent]: 'quotes.view.sidebar.timeline.delivery.email.sent',
  [QuoteEventType.DeliveryManualSent]: 'quotes.view.sidebar.timeline.delivery.manual.sent',
  [QuoteEventType.DocumentAccepted]: 'quotes.view.sidebar.timeline.document.accepted',
  [QuoteEventType.DocumentCreated]: 'quotes.view.sidebar.timeline.document.created',
  [QuoteEventType.DocumentDeleted]: 'quotes.view.sidebar.timeline.document.deleted',
  [QuoteEventType.DocumentEdited]: 'quotes.view.sidebar.timeline.document.edited',
  [QuoteEventType.DocumentInvoiced]: 'quotes.view.sidebar.timeline.document.invoiced',
  [QuoteEventType.DocumentRejected]: 'quotes.view.sidebar.timeline.document.rejected',
  [QuoteEventType.DocumentSent]: 'quotes.view.sidebar.timeline.document.sent',
  [QuoteEventType.DocumentUnaccepted]: 'quotes.view.sidebar.timeline.document.unaccepted',
  [QuoteEventType.DocumentUnrejected]: 'quotes.view.sidebar.timeline.document.unrejected',
  [QuoteEventType.DocumentUnsent]: 'quotes.view.sidebar.timeline.document.unsent',
  [QuoteEventType.DocumentPdfDownloaded]: 'quotes.view.sidebar.timeline.document.pdf.downloaded',
}
